export var EPreferences;
(function (EPreferences) {
    EPreferences["Announcement"] = "ANNOUNCEMENT";
    EPreferences["ChecklistExtraEntry"] = "CHECKLIST_EXTRA_ENTRY";
    EPreferences["ChecklistExtraExit"] = "CHECKLIST_EXTRA_EXIT";
})(EPreferences || (EPreferences = {}));
